<div class="circle-separator">
    <span >{{'VERTICAL_SEPARATOR_OR' | translate}}</span>
</div>